import router from '../../router'
import { AppNotification } from '../shared/notification'

export default {
  components: {
    AppNotification,
  },
  methods: {
    logoutUser() {
      return this.$store.dispatch('users/signOut')
        .then(response => {
          router.push({ name: 'Login' })
          this.$store.dispatch('clearAllData')

          return response
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.js